import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { PaymentIframeData } from './PaysafeFrameOptions';
import { PaysafePaymentProvider } from 'src/AppState/ConfigState/types';
import { PaysafeTabState } from './PaysafeTabState';

export interface PaysafeFramePropsType {
    paymentIframeData: PaymentIframeData;
    paysafeTabState: PaysafeTabState;
    paysafePaymentProvider: PaysafePaymentProvider;
}

export const PaysafeFrame = observer(
    'PaysafeFrame',
    ({ paymentIframeData, paysafeTabState, paysafePaymentProvider }: PaysafeFramePropsType): JSX.Element | null => {
        React.useEffect(() => {
            const iframeName = 'paysafe-iframe';

            if (document.getElementById(iframeName) !== null) {
                return;
            }

            const iframe = document.createElement('script');
            iframe.type = 'text/javascript';
            iframe.id = iframeName;
            iframe.src = `https://hosted.paysafe.com/checkout/v2/paysafe.checkout.min.js`;
            iframe.async = true;
            iframe.addEventListener('load', () => {
                //@ts-expect-error
                window.paysafe.checkout.setup(
                    paysafePaymentProvider.apiKey,
                    paymentIframeData.data,
                    paysafeTabState.paysafeResultCallback(paymentIframeData),
                    paysafeTabState.paysafeStateCallback
                );
            });

            document.body.appendChild(iframe);
            return () => {
                const existingScript = document.getElementById(iframeName);

                if (existingScript !== null) {
                    document.body.removeChild(existingScript);
                }
            };
        }, []);

        return <div></div>;
    }
);
